/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";

export default function AffiliateProgram() {
  return (
    <div className="Gallery-Wraps contact program">
      <main>
        {/* Program section start */}
        <section className="parent">
          <section
            // className=" pb-200 Partener photographs"
            className=" pb-55 Partener photographs"
            // data-background="assets/img/breadcrumb/routing.png"
            style={{
              backgroundSize: "cover",
              backgroundImage: 'url("assets/img/breadcrumb/routing.png")',
            }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center ">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center mt-20">
                    <h4 className="text-left second">Affiliate Program</h4>
                    <p className="w-50">Welcome to the affiliate center.</p>
                  </div>
                </div>
                <div
                  className="col-xl-12 col-lg-12 col-md-12 text-center m-auto pt-10"
                  style={{ zIndex: 9 }}
                >
                  <div className="image-outer-corner">
                    <img
                      className="w-32"
                      src="assets/img/gallery/Affiliate-image.png"
                      alt=""
                    />
                    <span className="inner-image-text">
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12">
                          <div className="text-contetn-left">
                            Join our affiliate program and start earning money
                            for every sale you send our way! Simply create your
                            account, place your linking code into your website
                            and watch your account balance grow as your visitors
                            become our customers.
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 btn-parent" style={{display:'none'}}>
                          <button
                            type="button"
                            className="btn btn-labeled btn-success"
                          >
                            <span className="btn-label">
                              <i className="fa fa-user-plus" />
                            </span>
                            Sign UP
                          </button>
                          <button
                            type="button"
                            className="btn btn-labeled btn-success right-blue"
                          >
                            <span className="btn-label">
                              <i className="fa fa-sign-in" />
                            </span>
                            Log IN
                          </button>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="parent">
            <section className=" pt-40 pb-100 Partener photographs">
              <div className="container">
                <div className="row ">
                  <div className="row text text-center mt-10">
                    <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                      <h4 className="text-left second">How does it work?</h4>
                      <p className="w-50">The process is very simple:</p>
                    </div>
                  </div>
                  <div
                    id="carouselExampleControls"
                    className="carousel slide"
                    data-bs-ride="carousel"
                  >
                    <div className="carousel-inner">
                      <div className="carousel-item">
                        <img
                          src="assets/img/gallery/step-01.png"
                          className="d-block m-auto"
                          alt="..."
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          src="assets/img/gallery/step-01.png"
                          className="d-block m-auto "
                          alt="..."
                        />
                      </div>
                      <div className="carousel-item active">
                        <img
                          src="assets/img/gallery/step-01.png"
                          className="d-block m-auto"
                          alt="..."
                        />
                      </div>
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center pt-50">
                    <h4 className="text-left second">Already an Affiliate?</h4>
                    <p className="w-50 second-section-a">
                      Please visit the{" "}
                      <span className="highlight-main-color">
                        {" "}
                        Affiliate Login page{" "}
                      </span>{" "}
                      and enter your username and password to gain access to
                      your account statistics, banners, linking code.
                    </p>
                  </div>
                  <div className="text-center mt-60 button-uper">
                    <Link to={'/create-custom-print'} className="large head banner">
                      Create GALLERY WALL
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </section>

        <UpperFooterSlider />
      </main>
    </div>
  );
}
